import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";
import { PostSchema } from "./postSchema";
import { isQueryReady } from "src/api/axiosClient/utils";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";
import axios from "axios";

type Options = {
    companyId: number | undefined;
    ssqId: number | undefined;
    campaignId: number | undefined;
    scoresQuery?: OlapScoresQuery;
    enabled?: boolean;
};

export const getOrganizationPostApiKey = "getCompanyPost" as const;

export const useGetOrganizationPost = (options: Options) => {
    const { companyId, ssqId, campaignId, scoresQuery, enabled = true } = options;

    const scoresQueryKey = scoresQuery ? JSON.stringify(scoresQuery) : undefined;

    const isEnabled = enabled && companyId !== undefined && ssqId !== undefined && campaignId !== undefined;
    const query = useQuery({
        cacheTime: 0,
        enabled: isEnabled,
        queryKey: [getOrganizationPostApiKey, companyId, ssqId, campaignId, scoresQueryKey],
        queryFn: async () => {
            const url = `/api/organizations/${companyId}/ssq/${ssqId}/campaign/${campaignId}/ssq-post`;

            try {
                return await loggedInApiCall.get(url.toString(), {
                    headers: {
                        Accept: "application/json",
                    },
                    params: {
                        ...scoresQuery,
                    },
                });
            } catch (error) {
                if (axios.isAxiosError(error) && error.response?.status === 404) {
                    return null;
                }
                throw error;
            }
        },
        select: (response) => {
            if (!response) {
                return;
            }

            const post = response.data;
            const data = zodParseWithLog(post, PostSchema, getOrganizationPostApiKey);
            return data;
        },
    });

    const isReady = isQueryReady(query, isEnabled);

    return {
        post: query.data,
        isReady,
        ...query,
    };
};
